import React from 'react';
var SnippylyArrowTool = function (props) {
    var children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-arrow-tool", { "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};
export default SnippylyArrowTool;
